document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.announcement-bar .note-list-container p:first-child').forEach((el) => {
        el.classList.add('active');
    });

    function rotateAnnouncements() {
        document.querySelectorAll('.announcement-bar .notes-container p.active').forEach((currentNote) => {
            if (currentNote.matches(':last-of-type')) {
                currentNote.classList.remove('active');
                const parent = currentNote.closest('.announcement-bar .note-list-container');
                parent.querySelector('p:first-child').classList.add('active');
                return;
            }
            currentNote.classList.remove('active');
            currentNote.nextElementSibling.classList.add('active');
        });
    }

    setInterval(rotateAnnouncements, 4000);
});

// function updateCountdown() {
//     const now = new Date();

//     // Get current time in CEST (UTC+2)
//     const cestOffset = 2 * 60; // CEST is UTC+2
//     const utc = now.getTime() + (now.getTimezoneOffset() * 60000);
//     const cestTime = new Date(utc + (cestOffset * 60000));

//     // Calculate next 3 AM CEST
//     let next3AM = new Date(cestTime);
//     next3AM.setHours(3, 0, 0, 0);

//     // If current CEST time is past 3 AM today, move to tomorrow's 3 AM
//     if (cestTime >= next3AM) {
//         next3AM.setDate(next3AM.getDate() + 1);
//     }

//     // Calculate time difference in CEST
//     const timeDiff = next3AM.getTime() - cestTime.getTime();

//     if (timeDiff <= 0) {
//         updateCountdown();
//         return;
//     }

//     // Calculate hours, minutes, seconds
//     const hours = Math.floor(timeDiff / (1000 * 60 * 60));
//     const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
//     const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

//     // Update individual spans
//     document.getElementById('hours').textContent = hours.toString().padStart(2, '0');
//     document.getElementById('minutes').textContent = minutes.toString().padStart(2, '0');
//     document.getElementById('seconds').textContent = seconds.toString().padStart(2, '0');
// }

// // Wait for DOM to load before starting timer
// document.addEventListener('DOMContentLoaded', function () {
//     updateCountdown();
//     setInterval(updateCountdown, 1000);
// });



